import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "../components/PageHero";
import { useLanguage } from "../i18n/LanguageContext";

const Projetos = () => {
  const { t } = useLanguage();
  const p = t.projects;
  return (
    <div data-testid="projects-page">
      <PageHero eyebrow={p.eyebrow} title={p.title} intro={p.intro} testid="projects-hero" />
      <section className="border-b border-synergia-line">
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 md:py-32">
          <div className="border-t border-synergia-line">
            {p.blocks.map((b, i) => (
              <div
                key={b.title}
                className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-16 py-12 border-b border-synergia-line"
                data-testid={`projects-block-${i}`}
              >
                <div className="md:col-span-2 font-montserrat font-semibold text-synergia-gold text-xl tracking-wider">
                  {String(i + 1).padStart(2, "0")}
                </div>
                <div className="md:col-span-4">
                  <h3 className="font-montserrat font-semibold text-xl md:text-2xl text-synergia-green leading-snug">
                    {b.title}
                  </h3>
                </div>
                <div className="md:col-span-6">
                  <p className="font-inter text-base leading-relaxed text-synergia-graphite/75">
                    {b.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="mt-16">
            <Link to="/contato" className="btn-primary" data-testid="projects-cta">
              {t.nav.contactCta} <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projetos;
